import { Link } from "react-router-dom";

function Projects({ datas }) {
  return (
    <section className="bg-bg-white pt-[30px] w-full bg-cover pb-[90px]">
      <div className="container mx-auto">
        <div className="md:w-full w-11/12 mx-auto flex items-start justify-start pb-[50px] border-b border-black border-opacity-10">
          <h3 className="text-black font-sfprobold md:text-5xl text-3xl font-extrabold max-w-[681px] md:leading-[56px] leading-[36px]">
            Check out the many exciting things we’re working on
          </h3>
        </div>
        <div className='mt-[48px] md:grid md:grid-cols-2 items-center gap-12 flex flex-col md:w-full w-11/12 mx-auto'>
          {datas.map((data, i) => (
            <div
              key={i}
              className="w-full md:h-[500px] cursor-pointer h-[216px] md:card-shadow mb-[80px] rounded-[4px] card-shadow-mobile"
              data-aos={(i + 1) % 2 ? "zoom-in-up" : "zoom-in-down"}
              data-aos-duration="800"
            >
              <Link to={`/our-works/${data.slug}`}>
                <div className=" w-full h-full mb-6 rounded-[4px] ">
                  <img
                    src={data.heroBg}
                    className="object-cover rounded-[4px] w-full h-full"
                    alt={data.title}
                  />
                </div>

                <div className="px-[12px]">
                <h3 className="text-[28px] leading-[36px] font-sfprobold md:pt-5 pt-2 pb-1 text-black">
                  {data.title}
                </h3>
                <p className="text-[18px] leading-[28px] font-sfpro text-black opacity-70">
                  {data.sub}
                </p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
